import { render, staticRenderFns } from "./AudioButton.vue?vue&type=template&id=68cd1c68&scoped=true&"
import script from "./AudioButton.vue?vue&type=script&lang=ts&"
export * from "./AudioButton.vue?vue&type=script&lang=ts&"
import style0 from "./AudioButton.vue?vue&type=style&index=0&id=68cd1c68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cd1c68",
  null
  
)

export default component.exports